import {
  forgotPasswordAPI,
  signInAPI,
  signUpAPI,
  resetPasswordAPI,
  verifyEmailAPI,
  resendVerificationAPI
} from "../api/auth.api";

export const verifyEmailService = async (token) => {
  return await verifyEmailAPI(token);
};

export const signUpService = async (userData) => {
  return await signUpAPI(userData);
};

export const signInService = async (email, password) => {
  return await signInAPI(email, password);
};

export const forgotPasswordService = async (email) => {
  return await forgotPasswordAPI(email);
};

export const resetPasswordService = async (token, password) => {
  return await resetPasswordAPI(token, password);
};

export const resendVerificationService = async () => {
  return await resendVerificationAPI();
};